import React from "react";
import { CurrentOrNextEventProvider } from "../../../../hooks/useCurrentOrNextEvent/useCurrentOrNextEvent";
import { useFeatureFlag } from "../../../../launch-darkly/useLaunchDarkly";
import { useAIMessageContext } from "../hooks/AIMessageContext";
import { useCollaborators } from "../hooks/useCollaborators";
import { AINextMeetingLink } from "./AINextMeetingLink";
import { CustomCollaborators } from "./CustomCollaborators";
import { TopCollaborators } from "./TopCollaborators";
import { TryClockwiseChecklist } from "./TryClockwiseChecklist";

export const SidebarQuickFeed = () => {
  const { loadingHistory } = useAIMessageContext();
  const [isUsingCustomCollaborators] = useFeatureFlag("rollout-custom-collaborators");
  const {
    topCollaborators,
    customCollaborators,
    loading: collaboratorsLoading,
  } = useCollaborators();

  if (loadingHistory) return null;

  return (
    <CurrentOrNextEventProvider>
      <div className="cw-flex cw-flex-col cw-gap-5 cw-w-full cw-h-full">
        <AINextMeetingLink />
        {/* TODO: Remove TopCollaborators and keep CustomCollaborators after flag rollout, Linear Task: CAL-893 */}
        {isUsingCustomCollaborators ? (
          <CustomCollaborators
            loading={collaboratorsLoading}
            topCollaborators={topCollaborators}
            customCollaborators={customCollaborators}
          />
        ) : (
          <TopCollaborators
            loading={collaboratorsLoading}
            topCollaborators={topCollaborators.slice(0, 6)}
          />
        )}
        <TryClockwiseChecklist />
      </div>
    </CurrentOrNextEventProvider>
  );
};
